import { DigitalMeterLog  } from "../../classes";

const DigitalMeterLogModule = {
  namespaced: true,
  state: {
  },
  actions: {
    getDigitalMeterLogBetweenDateByMarket: async ({ commit }, payload) => {
      try {
        const data = await DigitalMeterLog.getDigitalMeterLogBetweenDateByMarket(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {

  },
  mutations: {

  }
};
export default DigitalMeterLogModule;
